import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Form,
  TabContent,
  TabPane,
} from "reactstrap"
import Select from "react-select"
import { Link, useNavigate } from "react-router-dom"
import classnames from "classnames"
import { useFormik } from "formik"

import avatar5 from "../../assets/images/logo-sm.png"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { getProductList } from "../../redux/actions/user"
import { fetchPvsCategory } from "../../redux/actions/pvs"
import TagInput from "components/TagInput"
import ConfirmPopup from "components/ConfirmPopup"
import {
  getUserDetailsRequest,
  updateUserProfile,
} from "../../redux/actions/auth"

const UserBazaarInfo = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (token === null) {
      navigate("/login", { replace: true })
    } else {
      dispatch(getUserDetailsRequest())
      dispatch(fetchPvsCategory({ offset: 1 }))
    }
  }, [])

  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [selectedPvsCard, setSelectedPvsCard] = useState(null)
  const [pvsOptions, setPvsOptions] = useState([])
  const [productOptions, setProductOptions] = useState([])
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const user = useSelector(state => state.auth.user)
  const token = useSelector(state => state.auth.token)
  const products = useSelector(state => state.user.products)
  const pvs_cards = useSelector(state => state.auth.pvs_cards)
  const categoryList = useSelector(state => state.pvs.categoryList)
  const bazaars = useSelector(state => state.auth.dashboardData)
  const updateUserProfileScreen = useSelector(
    state => state.screens.updateUserProfile
  )

  useEffect(() => {
    if (
      pvs_cards &&
      pvs_cards.length > 0 &&
      categoryList &&
      categoryList.length > 0
    ) {
      let tempOptions = pvs_cards.map(card => ({
        ...card,
        label: card.token_code,
        value: card.token_code,
      }))
      setPvsOptions(tempOptions)

      let category = categoryList.find(
        val => val.pvs_cat_id === Number(tempOptions[0].categories)
      )
      dispatch(getProductList({ offset: 1 }))
      setSelectedPvsCard(
        tempOptions.find(
          val => val.token_code === bazaars?.active_bazaars[0]?.interested_pvs_card_number
        )
      )
    } else {
      setIsConfirmOpen(true)
    }
  }, [pvs_cards, categoryList])

  useEffect(() => {
    if (updateUserProfileScreen.success) {
      toast.success(updateUserProfileScreen.message)
    }
    if (updateUserProfileScreen.error) {
      toast.error(updateUserProfileScreen.error)
    }
  }, [updateUserProfileScreen])

  useEffect(() => {
    if (products) {
      let tempProductOption = products.map(option => ({
        label: option.product_label,
        value: option.product_id,
        encId: option.enc_product_id,
      }))
      setProductOptions(tempProductOption)
    }
  }, [products])

  useEffect(() => {
    if (selectedPvsCard && selectedPvsCard.billing) {
      formik.setValues({
        firstName: selectedPvsCard.billing.first_name || "",
        lastName: selectedPvsCard.billing.last_name || "",
        companyName: selectedPvsCard.billing.company_name || "",
        address: selectedPvsCard.billing.address || "",
        city: selectedPvsCard.billing.city || "Pune",
        state: selectedPvsCard.billing.state
          ? stateOptions[0].options.find(
              val => val.label === selectedPvsCard.billing.state
            )
          : stateOptions[0].options[20],
        pincode: selectedPvsCard.billing.pincode || "",
        gstNumber: selectedPvsCard.billing.gst_number || "",
        email: selectedPvsCard.billing.email_id || "",
        mobileNo: selectedPvsCard.billing.mobile_no || "",
        products: [],
        otherProducts: [],
      })
    }
    if (selectedPvsCard && selectedPvsCard.products && productOptions) {
      let productArr = selectedPvsCard.products.split(",")
      let selectedProducts = []
      productArr.forEach(product => {
        const foundProduct = productOptions.find(
          val => val.value === Number(product)
        )
        if (foundProduct) {
          selectedProducts.push(foundProduct)
        }
      })
      formik.setFieldValue("products", selectedProducts)
    }
  }, [selectedPvsCard, productOptions])

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  const stateOptions = [
    {
      options: [
        { label: "Andaman and Nicobar Islands", value: 4023 },
        { label: "Andhra Pradesh", value: 4017 },
        { label: "Arunachal Pradesh", value: 4024 },
        { label: "Assam", value: 4027 },
        { label: "Bihar", value: 4037 },
        { label: "Chandigarh", value: 4031 },
        { label: "Chhattisgarh", value: 4040 },
        { label: "Dadra and Nagar Haveli and Daman and Diu", value: 4033 },
        { label: "Delhi", value: 4021 },
        { label: "Goa", value: 4009 },
        { label: "Gujarat", value: 4030 },
        { label: "Haryana", value: 4007 },
        { label: "Himachal Pradesh", value: 4020 },
        { label: "Jammu and Kashmir", value: 4029 },
        { label: "Jharkhand", value: 4025 },
        { label: "Karnataka", value: 4026 },
        { label: "Kerala", value: 4028 },
        { label: "Ladakh", value: 4852 },
        { label: "Lakshadweep", value: 4019 },
        { label: "Madhya Pradesh", value: 4039 },
        { label: "Maharashtra", value: 4008 },
        { label: "Manipur", value: 4010 },
        { label: "Meghalaya", value: 4006 },
        { label: "Mizoram", value: 4036 },
        { label: "Nagaland", value: 4018 },
        { label: "Odisha", value: 4013 },
        { label: "Puducherry", value: 4011 },
        { label: "Punjab", value: 4015 },
        { label: "Rajasthan", value: 4014 },
        { label: "Sikkim", value: 4034 },
        { label: "Tamil Nadu", value: 4035 },
        { label: "Telangana", value: 4012 },
        { label: "Tripura", value: 4038 },
        { label: "Uttar Pradesh", value: 4022 },
        { label: "Uttarakhand", value: 4016 },
        { label: "West Bengal", value: 4853 },
      ],
    },
  ]

  document.title = "User Bazaar Info"

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const phoneRegex = /^[6-9]\d{9}$/

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      companyName: "",
      address: "",
      city: "Pune",
      state: stateOptions[0].options[20],
      pincode: "",
      gstNumber: "",
      email: "",
      mobileNo: "",
      products: [],
      otherProducts: [],
    },
    validate: values => {
      const errors = {}
      if (!values.firstName) errors.firstName = "Required"
      if (!values.lastName) errors.lastName = "Required"
      if (!values.companyName) errors.companyName = "Required"
      if (!values.address) errors.address = "Required"
      if (!values.city) errors.city = "Required"
      if (!values.state) errors.state = "Required"
      if (!values.pincode) errors.pincode = "Required"
      if (!values.email) errors.email = "Required"
      else if (!emailRegex.test(values.email)) errors.email = "Invalid email"
      if (!values.mobileNo) errors.mobileNo = "Required"
      else if (!phoneRegex.test(values.mobileNo))
        errors.mobileNo =
          "Invalid Mobile Number (should be 10 digits starting with 6-9)"
      // if (Array.isArray(values.products) && values.products.length === 0) {
      //   errors.products = "Required"
      // }
      return errors
    },
    onSubmit: values => {
      let requestData = {
        section: "bussiness",
        data: [
          {
            pvs_entry_id: selectedPvsCard.pvs_entry_id,
            products: values.products.map(product => product.value).join(","),
            other_products: values.otherProducts.join(", "),
            billing: {
              customer_type: "business",
              first_name: values.firstName,
              last_name: values.lastName,
              email_id: values.email,
              mobile_no: values.mobileNo,
              gst_number: values.gstNumber,
              company_name: values.companyName,
              region: values.region,
              address: values.address,
              city: values.city,
              state: values.state.label,
              pincode: values.pincode,
            },
          },
        ],
      }
      dispatch(updateUserProfile(requestData, token))
    },
  })

  const handlePvsCardChange = selectedOption => {
    let category = categoryList.find(
      val => val.pvs_cat_id === Number(selectedOption.categories)
    )
    dispatch(getProductList({ offset: 1 }))
    setSelectedPvsCard(selectedOption)
  }

  const onOtherProductsChange = list => {
    formik.setFieldValue("otherProducts", list)
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <div
          className="container-fluid"
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <div className="newaward-maincontainer pt-4 ">
            <div className="mb-4">
              <div
                className="p-4 rounded-3"
                style={{
                  background:
                    "linear-gradient(135deg, #f0fff4 0%, #e6f9ee 100%)",
                  border: "1px solid #9ad4b0",
                }}
              >
                <div className="d-flex align-items-start gap-3">
                  <div style={{ fontSize: "2rem", lineHeight: 1 }}>🎉</div>
                  <div>
                    <h4
                      className="mb-1"
                      style={{ color: "#1a6e3c", fontWeight: 700 }}
                    >
                      Thank You for Your Interest in Our Upcoming Bazaar!
                    </h4>
                    <p
                      className="mb-2 text-muted"
                      style={{ fontSize: "0.95rem" }}
                    >
                      We&apos;re thrilled to have you on board. To ensure a
                      seamless and hassle-free stall booking experience, we
                      kindly ask you to complete the details below ahead of
                      time.
                    </p>
                    <ul
                      className="mb-0 ps-3 text-muted"
                      style={{ fontSize: "0.9rem" }}
                    >
                      <li className="mb-1">
                        <strong>Product Details</strong> — Let us know what
                        you&apos;ll be showcasing so we can match you with the
                        right stall.
                      </li>
                      <li>
                        <strong>Billing Details</strong> — Ensure your invoices
                        are generated accurately and delivered to the right
                        place.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col xl={12}>
                <Form onSubmit={formik.handleSubmit}>
                  <Card>
                    <CardBody>
                      <div className="mb-3">
                        <Label htmlFor="pvsCards" className="form-label">
                          Selected PVS Card{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="pvsCards"
                          name="pvsCards"
                          options={pvsOptions}
                          classNamePrefix="select"
                          placeholder="Select your PVS Card..."
                          value={selectedPvsCard}
                          onChange={handlePvsCardChange}
                          isDisabled
                        />
                      </div>

                      <h3 className="nom-title mt-4">Product Details</h3>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="products">
                          Select Product from the dropdown{" "}
                          {/* <span className="text-danger">*</span> */}
                        </Label>
                        <Select
                          id="products"
                          name="products"
                          isMulti
                          options={productOptions}
                          classNamePrefix="select"
                          placeholder="Search the product..."
                          value={formik.values.products}
                          onChange={val =>
                            formik.setFieldValue("products", val)
                          }
                          onBlur={() =>
                            formik.setFieldTouched("products", true)
                          }
                        />
                        {formik.errors.products && (
                          <div className="text-danger small mt-1">
                            {formik.errors.products}
                          </div>
                        )}
                      </div>

                      <div className="mb-3 mt-4">
                        <TagInput
                          tags={formik.values.otherProducts}
                          title="Other Products: If you don't find your product in the list above, please type it here to add it."
                          onChange={onOtherProductsChange}
                        />
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <h3 className="nom-title">Billing Details</h3>

                      {/* Primary Contact: First Name + Last Name */}
                      <div className="mb-3 row mt-3">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="first_name">
                            Primary Contact &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm">
                          <div className="row">
                            <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                              <Input
                                name="firstName"
                                className="form-control"
                                placeholder="First Name"
                                type="text"
                                id="first_name"
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.firstName && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.firstName}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-6">
                              <Input
                                name="lastName"
                                className="form-control"
                                placeholder="Last Name"
                                id="last_name"
                                type="text"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.lastName && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.lastName}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Contact Info: Email + Mobile No */}
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="emailr">
                            Contact Info &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm">
                          <div className="row">
                            <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                              <Input
                                name="email"
                                className="form-control"
                                placeholder="Email ID"
                                type="email"
                                id="emailr"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.email && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.email}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-6">
                              <Input
                                name="mobileNo"
                                className="form-control"
                                placeholder="Mobile Number"
                                type="number"
                                id="Mob_number"
                                value={formik.values.mobileNo}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.mobileNo && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.mobileNo}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Company Info: Company Name + GST Number */}
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="company_name">
                            Company Info &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm">
                          <div className="row">
                            <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                              <Input
                                name="companyName"
                                className="form-control"
                                placeholder="Company Name"
                                type="text"
                                id="company_name"
                                value={formik.values.companyName}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.companyName && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.companyName}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-6">
                              <Input
                                name="gstNumber"
                                className="form-control"
                                placeholder="GST Number"
                                type="text"
                                id="gst_number"
                                value={formik.values.gstNumber}
                                onChange={formik.handleChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Address */}
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="address">
                            Address &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm-9">
                          <textarea
                            name="address"
                            className="form-control"
                            id="address"
                            rows="3"
                            value={formik.values.address}
                            onChange={formik.handleChange}
                          ></textarea>
                          {formik.errors.address && (
                            <div className="text-danger small mt-1">
                              {formik.errors.address}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* State & City: State + City + Pincode */}
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="state">
                            State & City &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm">
                          <div className="row">
                            <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                              <Select
                                name="state"
                                value={formik.values.state}
                                onChange={val =>
                                  formik.setFieldValue("state", val)
                                }
                                options={stateOptions}
                                classNamePrefix="select2-selection"
                                placeholder="State"
                              />
                              {formik.errors.state && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.state}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                              <Input
                                name="city"
                                className="form-control"
                                placeholder="City"
                                type="text"
                                id="city"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.city && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.city}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-4">
                              <Input
                                name="pincode"
                                className="form-control"
                                placeholder="Pin Code"
                                type="number"
                                id="pincode"
                                value={formik.values.pincode}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.pincode && (
                                <div className="text-danger small mt-1">
                                  {formik.errors.pincode}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>

                  <div className="d-flex justify-content-center mt-4">
                    <Button type="submit" className="primary-button mb-3">
                      Submit
                    </Button>
                  </div>
                </Form>
              </Col>

              <Col xl={3}>
                <div className="user-sidebar" hidden>
                  <Card>
                    <CardBody>
                      <div className=""></div>
                      <div className="mt-n4 position-relative">
                        <div className="text-center">
                          <img
                            src={avatar5}
                            alt=""
                            className="avatar-xl rounded-circle img-thumbnail"
                          />
                          <div className="mt-3">
                            <h3 className="">{`${user?.first_name} ${
                              user?.last_name ? user?.last_name[0] : ""
                            }`}</h3>
                            <div>
                              <Link to="#" className="text-muted m-1">
                                PVS ID: {user?.pvs_card_number}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="p-3 mt-3">
                        <Row className="text-center">
                          <Col>
                            <div className="p-1">
                              <h3 className="mb-1">
                                {formik.values.products
                                  ? formik.values.products.length
                                  : 0}
                              </h3>
                              <p className="text-muted mb-0">Products</p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <ConfirmPopup
          title="Unauthorized"
          isOpen={isConfirmOpen}
          message={
            "You need to be a PVS Member to proceed. Please become a PVS Member to proceed."
          }
          onConfirm={() => {
            navigate("/pvs-registration", { replace: true })
          }}
          confirmText="Become a PVS Member"
          cancelText="I'll do it later"
          toggle={() => {
            setIsConfirmOpen(!isConfirmOpen)
            navigate("/home", { replace: true })
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default UserBazaarInfo
